import React from 'react';

const SuperAdminRejectedSheet = () => {
    return (
        <div style={{ fontFamily: "Arial, sans-serif", margin: "0", padding: "0", overflowX: "hidden" }}>
            <div>
                <h2 style={{ fontSize: "22px", fontWeight: "500", color: "#000000", margin: "0 0 10px 0" }}>
                    How to track the Rejected Timesheets?
                </h2>
                <p style={{ fontSize: "16px", color: "#333", lineHeight: "1.5" }}>
                    The "Rejected Time Sheets" section provides a detailed overview of all timesheets that have been declined by the "Approval Manager" or "Super Admin."
                    Once a timesheet is rejected, it means that the submission did not meet the necessary requirements or contained errors that need correction. 
                    This section helps both employees and managers track and review rejected timesheets, understand the reasons for rejection, and take necessary actions.
                </p>

                <h4 style={{ fontSize: "18px", fontWeight: "600", margin: "15px 0 0 0", color: "#000" }}>Understanding Rejected Time Sheets</h4>
                <p style={{ fontSize: "16px", color: "#333", lineHeight: "1.5" }}>
                    When a timesheet is rejected, it is essential to understand the reason behind the rejection. 
                    The rejection could be due to incorrect working hours, missing information, policy violations, or discrepancies in the data provided.
                    Employees should review the comments provided by the approvers and make the necessary corrections before resubmitting the timesheet.
                </p>

                <h4 style={{ fontSize: "18px", fontWeight: "600", margin: "15px 0 0 0", color: "#000" }}>Tracking Rejected Time Sheets</h4>
                <p style={{ fontSize: "16px", color: "#333", lineHeight: "1.5" }}>
                    The rejected timesheets are stored in the system for record-keeping and future reference. 
                    Employees and managers can access these records to identify common issues and prevent repeated mistakes in future submissions.
                    It is recommended to review the rejected timesheets regularly and ensure timely resubmission.
                </p>

                <img
                    src="https://res.cloudinary.com/danfpnuui/image/upload/v1737466051/Screenshot_2025-01-21_153246_oxsuwu.png"
                    alt="Rejected Timesheet Screenshot"
                    style={{ width: "60%" }}
                />

                <h4 style={{ fontSize: "18px", fontWeight: "600", margin: "15px 0 0 0", color: "#000" }}>Step-by-Step Guide to Access Rejected Time Sheets</h4>
                <p style={{ fontSize: "16px", color: "#333", lineHeight: "1.5" }}>
                    <strong>Step 1:</strong> Log in to your dashboard using your credentials.  
                    <br />
                    <strong>Step 2:</strong> Navigate to the "Sidebar Menu" and select the "Rejected Sheets" option.  
                    <br />
                    <strong>Step 3:</strong> Here, you will find a list of all rejected timesheets along with details such as the submission date, employee name, and rejection comments.  
                    <br />
                    <strong>Step 4:</strong> Review the provided comments to understand why the timesheet was rejected.  
                    <br />
                    <strong>Step 5:</strong> Make the necessary corrections and resubmit the timesheet for approval.  
                </p>

                <h4 style={{ fontSize: "18px", fontWeight: "600", margin: "15px 0 0 0", color: "#000" }}>Actions You Can Take</h4>
                <ul style={{ fontSize: "16px", color: "#333", lineHeight: "1.5", paddingLeft: "20px" }}>
                    <li>If you are an employee, carefully check the comments provided by the approver and modify your timesheet accordingly before resubmitting it.</li> 
                    <li>If you are a manager, ensure that employees are aware of their mistakes and guide them on how to make corrections.</li>  
                    <li>If there are recurring issues with rejected timesheets, consider training employees on correct submission practices.</li> 
                </ul>

                <img
                    src="https://res.cloudinary.com/danfpnuui/image/upload/v1740685482/WhatsApp_Image_2025-02-26_at_9.37.25_PM_nsj55c.jpg"
                    alt="Rejected Timesheet Screenshot"
                    style={{ width: "60%" }}
                />

                <p style={{ fontSize: "16px", color: "#333", lineHeight: "1.5", margin: "15px 0 0 0" }}>
                    The screenshot above shows how rejected timesheets appear in the system. You can use this section to track rejected entries, understand their reasons, and take corrective action.
                </p>

                <h4 style={{ fontSize: "18px", fontWeight: "600", margin: "15px 0 0 0", color: "#000" }}>Tip:</h4>
                <p style={{ fontSize: "16px", color: "#333", lineHeight: "1.5" }}>
                    You can add a comment for employees such as: <strong>“Please resubmit your timesheets.”</strong>  
                </p>

                <h4 style={{ fontSize: "18px", fontWeight: "600", margin: "15px 0 0 0", color: "#000" }}>Note:</h4>
                <p style={{ fontSize: "16px", color: "#333", lineHeight: "1.5" }}>
                    If needed, you can also download the rejected timesheets for reference or documentation purposes.  
                </p>
            </div>
        </div>
    );
};

export default SuperAdminRejectedSheet;
